module.exports = __webpack_public_path__ + "img/jukua-sell.3d805ce5.png";